import * as Yup from 'yup';

export default Yup.object().shape({
  promotionCode: Yup.string()
    .strict(true)
    .trim('Promo code cannot include leading and trailing spaces')
    .required('Required'),
});
